import { EmpModel } from "../models/EmpModel"
export const initialEmps: EmpModel[] = [
    {
        badgeNo: "1001",
        firstName: "Susan",
        lastName: "Bones",
        active: true,
        isSupervisor: false,
        isStocker: false,
        department: "PROD",

    },
    {   
        badgeNo: "1002",
        firstName: "Cedric",
        lastName: "Diggory",
        active: true,
        isSupervisor: false,
        isStocker: false,
        department: "PROD",
    },
    {   
        badgeNo: "1000",
        firstName: "Padma",
        lastName: "Patil",
        active: true,
        isSupervisor: false,
        isStocker: false,
        department: "PROD",
    },
    {   
        badgeNo: "2001",
        firstName: "Cho",
        lastName: "Chang",
        active: true,
        isSupervisor: false,
        isStocker: false,
        department: "MAINT",
    },
    {   
        badgeNo: "2002",
        firstName: "Luna",
        lastName: "Lovegood",
        active: true,
        isSupervisor: false,
        isStocker: false,
        department: "MAINT",
    },
    {   
        badgeNo: "2000",
        firstName: "Hannah",
        lastName: "Abbott",
        active: true,
        isSupervisor: false,
        isStocker: false,
        department: "MAINT",
    },
    {   
        badgeNo: "3000",
        firstName: "Adrian",
        lastName: "Pucey",
        active: true,
        isSupervisor: false,
        isStocker: false,
    },
    {   
        badgeNo: "3001",
        firstName: "Marcus",
        lastName: "Flint",
        active: true,
        isSupervisor: false,
        isStocker: false,
    },
    {   
        badgeNo: "4000",
        firstName: "Lee",
        lastName: "Jordan",
        active: true,
        isSupervisor: true,
        isStocker: false,
        department: "ENG",
    },
    {   
        badgeNo: "5000",
        firstName: "Oliver",
        lastName: "Wood",
        active: true,
        isSupervisor: false,
        isStocker: true,
        department: "OPR",
    },
    
      
]